import { render, staticRenderFns } from "./person.vue?vue&type=template&id=7e41b412"
import script from "./person.vue?vue&type=script&setup=true&lang=js"
export * from "./person.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports